export const bodyContent = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Area 51</title>
    <style>
        body {
            margin: 0;
            font-family: Arial, sans-serif;
            background-color: #101c52;
            color: white;
            text-align: center;
        }

        .container {
            max-width: 750px;
            margin: 0 auto;
            text-align: center;
            background-image: url("https://imagedelivery.net/eE656fmVeD1Y-PS_mBBsdQ/9caa4de3-36eb-49ac-a77a-9147d7300600/public2");
            background-size: cover;
            background-repeat: no-repeat;
        }

        .innerContainer {
            max-width: 600px;
            margin: 0 auto;
            place-items: center;
        }

        .logoImage {
            margin-top: 20px;
            width: 23vw;
            max-width: 180px;
        }

        .title {
            font-size: 5vw;
            font-weight: bold;
            margin: 64px 0 12px 0;
            background-color: #101c52;
            color: white;
        }

        .subtitle {
            font-size: 3vw;
            font-weight: lighter;
            margin-bottom: 30px;
            background-color: #101c52;
            color: white;
        }

        .promoImage {
            width: 35vw;
            max-width: 300px;
        }

        .code-section {
            font-size: 3vw;
            font-weight: lighter;
            border-radius: 10px;
            margin-top: 35px;
            margin-bottom: 25px;
            text-align: center;
            display: block;
            gap: 10px;
            background-color: #101c52;
            color: white;
        }

        .code-section span {
            font-weight: bold;
        }

        .validity {
            font-size: 3vw;
            font-weight: lighter;
            margin-bottom: 25px;
            text-align: center;
            display: block;
            gap: 10px;
            background-color: #101c52;
            color: white;
        }

        .validity .iconContainer, .code-section .iconContainer {
            display: inline-block;
            padding-bottom: 7px;
        }

        .validity .icon, .code-section .icon {
            border: 1px solid grey;
            border-radius: 100%;
            padding: 2px;
        }

        .validity .icon img, .code-section .icon img {
            padding: 5px;
        }

        .code-section p, .validity p, .cta p {
            margin: 0;
        }

        .cta {
            font-size: 2.9vw;
            font-weight: bold;
            margin-top: 40px;
            padding: 0 25px;
            margin-bottom: 40px;
            display: flex;
            gap: 3px;
            background-color: #101c52;
            color: white;
        }

        .cta p {
            padding: 0 4px;
        }

        .link {
            display: inline-block;
            padding-bottom: 60px;
            font-size: 3vw;
            font-weight: bold;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            background-color: #101c52;
            color: white;
        }

        .link a {
            color: white;
        }

        .svgStar {
            width: 17px;
            height: 17px;
        }

        .svgDot {
            width: 7px;
            height: 7px;
        }

        @media screen and (min-width: 600px) {
            .title {
                font-size: 30px;
            }

            .subtitle {
                font-size: 21px;
            }

            .code-section, .validity {
                font-size: 22px;
            }

            .cta {
                font-size: 18px;
            }

            .link {
                font-size: 20px;
            }
        }

        @media screen and (max-width: 350px) and (min-width: 0) {
            .title {
                margin: 10px 0 6px 0;
                font-size: 4vw;
            }

            .subtitle {
                font-size: 2.8vw;
                margin-bottom: 10px;
            }

            .promoContainer{
                margin-bottom: 10px;
            }

            .code-section, .validity {
                font-size: 2.8vw;
                margin-top: 0;
                margin-bottom: 10px;
                padding: 0 10px;
            }

            .cta {
                font-size: 2.5vw;
                padding: 0 25px;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .cta p {
                padding: 0 2px;
            }

            .link {
                font-size: 2.8vw;
                padding-bottom: 20px;
            }

            .svgStar {
                width: 7px;
                height: 7px;
            }

            .svgDot {
                width: 5px;
                height: 5px;
            }
        }

        @media screen and (max-width: 350px) and (min-width: 0) {
            .validity .icon, .code-section .icon {
                padding: 6px;
            }
        }
    </style>
</head>
<body>
<div class="container">
    <div class="innerContainer">
        <div class="logoContainer">
            <img src="https://imagedelivery.net/eE656fmVeD1Y-PS_mBBsdQ/e39e7a2a-b1cc-4469-b5fe-ad01dc5cfe00/public" alt="Area 51 Logo" class="logoImage">
        </div>
        <div class="title">ΣΥΓΧΑΡΗΤΗΡΙΑ, ΕΙΣΑΙ ΝΙΚΗΤΗΣ!🚀</div>
        <div class="subtitle">
            Έχεις μόλις ξεκλειδώσει 20% έκπτωση στο e-shop μας<br>
            για τις κατηγορίες SPECIALTY ΚΑΦΈΔΕΣ και MERCHANDISE!
        </div>
        <div class="promoContainer">
            <img src="https://imagedelivery.net/eE656fmVeD1Y-PS_mBBsdQ/461135e5-2604-4072-4ebb-1d25b6885500/public" alt="Area 51 Promo" class="promoImage">
        </div>
        <div class="code-section">
            <div class="iconContainer">
                <div class="icon">🛒</div>
            </div>
            <p>
                Χρησιμοποίησε τον εκπτωτικό κωδικό:
                <span>"AREA20"</span>
                και μπες στον γαλαξία των γεύσεων!
            </p>
        </div>
        <div class="validity">
            <div class="iconContainer">
                <div class="icon">📅</div>
            </div>
            <p>
                Ισχύει από 07/02/2025 έως και 07/03/2025,<br>
                οπότε μην το αφήσεις να χαθεί στο διάστημα!
            </p>
        </div>
        <div class="cta">
            <img src="https://imagedelivery.net/eE656fmVeD1Y-PS_mBBsdQ/0e3dd6c2-6c37-467f-301a-65ed67a4dd00/public" alt="Area 51 Dot" class="svgDot">
            <img src="https://imagedelivery.net/eE656fmVeD1Y-PS_mBBsdQ/d2bf6982-8bc1-454b-1899-4d91136e5800/public" alt="Area 51 Star" class="svgStar">
            <p>ΑΠΟΛΑΥΣΕ ΤΟΝ ΚΑΦΕ ΠΟΥ ΕΙΝΑΙ OUT OF THIS WORLD!</p>
            <img src="https://imagedelivery.net/eE656fmVeD1Y-PS_mBBsdQ/d2bf6982-8bc1-454b-1899-4d91136e5800/public" alt="Area 51 Star" class="svgStar">
            <img src="https://imagedelivery.net/eE656fmVeD1Y-PS_mBBsdQ/0e3dd6c2-6c37-467f-301a-65ed67a4dd00/public" alt="Area 51 Dot" class="svgDot">
        </div>
        <div class="link">🚀
            <a target="_blank" href="https://area51coffeeroasters.com/en/shop/">
                ΕΞΑΡΓΥΡΩΣΕ ΤΟΝ ΚΩΔΙΚΟ ΣΟΥ ΤΩΡΑ!
            </a>
        </div>
    </div>
</div>
</body>
</html>
`;